// removed by extract-text-webpack-plugin
module.exports = {"events":"Events__events--127iO"};


//////////////////
// WEBPACK FOOTER
// ./src/events/components/Events/Events.css
// module id = ./src/events/components/Events/Events.css
// module chunks = 2